import { cn } from '@/lib/utils';

export interface HeartbeatWaveProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size applied to both width and height.
   */
  size?: number;
  /**
   * Optional explicit width (overrides size).
   */
  width?: number;
  /**
   * Optional explicit height (overrides size).
   */
  height?: number;
  /**
   * Stroke color for the heartbeat wave.
   */
  color?: string;
}

export function HeartbeatWave({
  size = 18,
  width,
  height,
  color = 'currentColor',
  className,
  ...props
}: HeartbeatWaveProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      {/* Monitor frame */}
      <path
        d="M5.5 3.75h13c2.1 0 3.75 1.65 3.75 3.75v7c0 2.1-1.65 3.75-3.75 3.75h-13c-2.1 0-3.75-1.65-3.75-3.75v-7c0-2.1 1.65-3.75 3.75-3.75Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />

      {/* Single ECG wave */}
      <path
        d="M5.8 10.5h2.9l1.5-2.4 2.3 4.7 1.5-2.3h4"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />

      {/* Monitor stand */}
      <path
        d="M12 18.2v2.05M8.75 21h6.5"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
